export enum TabSteps {
  TARIFF_PLAN = 0,
  PERSONAL_INFORMATION = 1,
  DELIVERY = 2,
  PAYMENT = 3,
}

export enum EPaymentTypes {
  BIRBANK = 0,
  WEBSITE = 1,
}

export enum DeliveryType {
  SELF_PICKUP = 'self-pickup',
  DELIVERY_TO_ADDRESS = 'delivery-to-address',
}

export enum NumberSalePrefixIds {
  All = '0',
  Prefix055 = '1',
  Prefix099 = '2',
}

export enum NumberLevels {
  All = '',
  Simple = 'SIMPLE',
  Bronze = 'BRONZE',
  Silver = 'SILVER',
  Gold = 'GOLD',
  Platinum = 'PLATINUM',
}

export enum FaceResultStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  SUCCESS = 'SUCCESS',
  NOT_VERIFIED = 'NOT_VERIFIED',
  MHM_ERROR = 'MHM_ERROR',
  ERROR = 'ERROR',
}

export enum EVerificationMethods {
  FACE = 1,
  SIMA = 2,
}

export enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
  INITIAL = 'INITIAL',
  IN_PROGRESS = 'IN_PROGRESS',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  CANCELED = 'CANCELED',
  TIMEOUT = 'TIMEOUT',
  REVERSED = 'REVERSED',
  NOT_FOUND = 'NOT_FOUND',
}

export enum FinalizeStatus {
  UNCOMPLETED_FINALIZE = 'UNCOMPLETED_FINALIZE',
  SUCCESS = 'SUCCESS',
}
